const _version = "3.1.3"
function version() {
    return _version
}
export default version
